import { SearchPredicate } from '@nx-smartmonkey/shared/domain';
import { PaginatedResult } from '@nx-smartmonkey/shared/interfaces';

import { GeoFence } from '../../domain/geoFence/GeoFence';
import { FlatProject } from '../../domain/project/FlatProject';
import { Project } from '../../domain/project/Project';
import { ProjectUser } from '../../domain/project/ProjectUser';
import { Stop } from '../../domain/stop/Stop';
import { StopFlat } from '../../domain/stop/StopFlat';
import { VehicleFlat } from '../../domain/vehicle/VehicleFlat';
import { ProjectActionType, ProjectActions } from './actions';
import { ProjectStopsTableColumn, getProjectStopsTableColumns, setProjectStopsTableColumns } from './tableColumns';

const defaultPagination = {
  limit: 20,
  offset: 0,
  total: 0,
  docs: [],
} as PaginatedResult<Stop>;

export interface ProjectState {
  flatProjects: FlatProject[];
  activeProject?: Project;
  stops: {
    flat: Array<StopFlat>;
    pagination: PaginatedResult<Stop>;
    tableColumns: Array<ProjectStopsTableColumn>;
    selectedStops: Array<string>;
    predicates: Array<SearchPredicate>;
    predicatesBase64: string;
  };
  vehicles: {
    flat: Array<VehicleFlat>;
  };
  users?: Array<ProjectUser>;
  geoFences: Array<GeoFence>;
}

export const getInitialState = (): ProjectState => ({
  flatProjects: [],
  activeProject: undefined,
  stops: {
    flat: [],
    pagination: defaultPagination,
    tableColumns: getProjectStopsTableColumns(),
    selectedStops: [],
    predicates: [],
    predicatesBase64: ``,
  },
  vehicles: {
    flat: [],
  },
  users: undefined,
  geoFences: [],
});

export const ProjectReducer = (state: ProjectState, action: ProjectActions): ProjectState => {
  switch (action.type) {
    case ProjectActionType.SET_SEARCH_PROJECT_STOPS_PREDICATES: {
      const { predicates, predicatesBase64 } = action.payload;
      return {
        ...state,
        stops: {
          ...state.stops,
          predicates,
          predicatesBase64,
        },
      };
    }
    case ProjectActionType.SET_SELECTED_STOPS:
      return {
        ...state,
        stops: {
          ...state.stops,
          selectedStops: action.payload.selectedStops,
        },
      };
    case ProjectActionType.SET_PROJECT_STOPS_TABLE_COLUMNS:
      setProjectStopsTableColumns(action.payload);
      return {
        ...state,
        stops: {
          ...state.stops,
          tableColumns: action.payload,
        },
      };
    case ProjectActionType.FETCH_PROJECTS_SUCCESS:
      return {
        ...state,
        flatProjects: action.payload.flatProjects,
        stops: {
          flat: [],
          pagination: defaultPagination,
          tableColumns: getProjectStopsTableColumns(),
          selectedStops: [],
          predicates: [],
          predicatesBase64: ``,
        },
      };
    // case ProjectActionType.PROJECTS_CREATE_PROJECT_SUCCESS:
    //   return {
    //     ...state,
    //     flatProjects: [...(state.flatProjects ?? []), action.payload.project],
    //   };
    case ProjectActionType.SET_ACTIVE_PROJECT:
      return {
        ...state,
        activeProject: action.payload.activeProject,
      };
    // case ProjectActionType.PROJECTS_EDIT_PROJECTS_RESOURCES_SUCCESS:
    //   // Updates the projects resources.
    //   return {
    //     ...state,
    //     flatProjects: action.payload.projects,
    //   };
    case ProjectActionType.SEARCH_STOPS_SUCCESS:
      return {
        ...state,
        stops: {
          ...state.stops,
          pagination: action.payload.stopsPagination,
        },
      };
    case ProjectActionType.SEARCH_FLAT_STOPS_SUCCESS:
      return {
        ...state,
        stops: {
          ...state.stops,
          flat: action.payload.flatStops,
        },
      };
    case ProjectActionType.SEARCH_FLAT_VEHICLES_SUCCESS:
      return {
        ...state,
        vehicles: {
          flat: action.payload.flatVehicles,
        },
      };
    case ProjectActionType.ON_SELECT_STOP: {
      const { stopId, withControlKey } = action.payload;
      let selectedStops = [stopId];

      if (withControlKey) {
        selectedStops = state.stops.selectedStops.includes(stopId)
          ? state.stops.selectedStops.filter((id) => id !== stopId)
          : [...state.stops.selectedStops, stopId];
      }

      return {
        ...state,
        stops: {
          ...state.stops,
          selectedStops,
        },
      };
    }
    case ProjectActionType.FETCH_PROJECT_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload.users,
      };
    case ProjectActionType.FETCH_PROJECT_GEOFENCES_SUCCESS:
      return {
        ...state,
        geoFences: action.payload.geoFences,
      };
    case ProjectActionType.RESET_PROJECT:
      return getInitialState();
    default:
      return state;
  }
};
